/* global BigInt */

export const formatPlanRatio = (value) => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  const match = String(value)
    .trim()
    .match(/^(-?)(\d+)(?:\.(\d+))?$/);
  if (!match) {
    return '-';
  }
  const scale = 4;
  const fraction = match[3] || '';
  const scaleFactor = 10n ** BigInt(scale);
  let percentageHundredths = BigInt(match[2]) * scaleFactor;
  percentageHundredths += BigInt(fraction.slice(0, scale).padEnd(scale, '0'));
  if (fraction[scale] >= '5') {
    percentageHundredths += 1n;
  }
  const sign = match[1] && percentageHundredths !== 0n ? '-' : '';
  return `${sign}${percentageHundredths / 100n}.${String(percentageHundredths % 100n).padStart(2, '0')}%`;
};
